import { useSelector } from 'react-redux';

const useIsShortlisted = (optId) => {
  const shortlist = useSelector((state) => state.shortlistRed.shortlistedOptions);

  const checkIfShortlisted = (id, shortlist) => {
    const found = shortlist.find((item) => item.optionId === id);

    if (found) {
      return 'active';
    }

    return 'inactive';
  };

  return checkIfShortlisted(optId, shortlist);
};

export default useIsShortlisted;
